import React, {useState, useEffect, useContext, useRef} from "react";
import toast from "react-hot-toast";
import axios from "axios";
import Cards from 'react-credit-cards-2';
import 'react-credit-cards-2/dist/es/styles-compiled.css';
import { ProductContext } from "../../context/ProductContext";
import { getURLBasePath, porcentajeADecimal } from "../tools/utils";

export default function FormPago({onClickTotalCuotas, onTarjetaSeleccionada, onAnioExp, onMesExp, onNumeroTarjeta, onCvv, onTipoDocumento, onNumeroDocumento, onTitularTarjeta,onBancoSeleccionado, onTasa, onCantidadCuotas, permitirTiparMontos, onMontoTipado, onMontoTotalPayway = () => {} }) { 

  const { reserva } =  useContext(ProductContext);
  

const [datosTarjetas, setDatosTarjetas] = useState([]); // TRAIGO TARJETAS 
const [tarjetaSeleccionada, setTarjetaSeleccionada] = useState(null); // SELECCION DE TARJETA 
const [traerBancos, setTraerBancos] = useState([]) // TRAIGO BANCOS 
const [bancoSeleccionado, setBancoSeleccionado] = useState(null);  // BANCO SELECCIONADO
const [cuotasDisponibles, setCuotasDisponibles] = useState([]); // TRAIGO CUOTAS DISPONIBLES
const [cuotas, setCuotasState] = useState(''); // SELECCIONO LA CUOTA CON EL PORCENTAJE 
const [numeroTarjeta, setNumeroTarjetaState] = useState(''); // NUMERO DE TARJETA
const [titularTarjeta, setTitularTarjetaState] = useState(''); // TITULAR DE LA TARJETA
const [cvv, setCvvState] = useState(''); // CVV DE LA TARJETA
const [mesExp, setMesExpState] = useState(''); // MES EXP TARJETA
const [anioExp, setAnioExpState] = useState(''); // ANIO EXP TARJETA
const [traerDocumentos, setTraerDocumentos] = useState([])// TRAIGO ABM DE DOCUMENTOS.
const [documentoSeleccionado, setNumeroDocumentoSeleccionado] = useState([]); // TIPO DOCUMENTO SELECCIONADO
const [numeroDocumento, setNumeroDocumentoState] = useState(''); // NUMERO DOCUMENTO
const [permiteTiparMontos, setPermiteTiparMontos] = useState(permitirTiparMontos || false);
const [totalParaPayway,setTotalParaPayway] = useState(0);
const [montoTipado, setMontoTipado] = useState(reserva?.saldoReserva || 0);
const inputFocusRef = useRef(null);

const [focusedField, setFocusedField] = useState('');
const [formularioYaEnviado, setFormularioYaEnviado] = useState(false);

    useEffect(() => {
       const fetchDataTarjetas = async () => {
        try { 
            const obj = {
                "peticion": 5,
            "idTipoInstrumento": 3
            }
            const response = await axios.post ('https://estanciamargarita.com.ar/backendGama/php/servicios/serviciosGenerales.php', obj);
            if (response.data && response.data.length > 0) {
                //console.log("Tarjetas obtenidas :", response.data);
                const objetoSinDiscriminar = response.data;
              const  newArray = objetoSinDiscriminar.filter((t) => {
            return parseInt(t.idTarjetaG) !== 5 && parseInt(t.idTarjetaG) !== 8;
           }) 

                setDatosTarjetas(newArray);
                //console.log(datosTarjetas)
            }
        }
        catch (error) {
            console.error("Error al obtener las tarjetas:", error);
            toast.error("Error al obtener las tarjetas");
        }
    };

        const fetchTraerBancos = async () => {
            try {
              const obj = {  "peticion": 6,"estado":1}
                         const response = await axios.post('https://estanciamargarita.com.ar/backendGama/php/servicios/serviciosBancos.php',obj);

                         if(response.data && response.data.length > 0) {
                          //console.log(response.data)
                          setTraerBancos(response.data)
                         }

            }
            catch(error){
              console.error('Error al traer los bancos.', error)
            }

        }

        const traerDocumentos = async () => {
          try {
       const data = { peticion: 8 };
            const url = `${getURLBasePath()}/serviciosEmpleados.php`;
           const response = await axios.post(url, data);
           if(response.data){
            setTraerDocumentos(response.data)
           }
          }
          catch(error){
            console.error('Error al traer Documentos', error)

          }
        }
        traerDocumentos();
      fetchDataTarjetas();
      fetchTraerBancos();
  }, []);

    useEffect(() => {
      if (!tarjetaSeleccionada) return;
      if(!bancoSeleccionado) return;

      const traerCuotas = async () => {
        const tarjeta = datosTarjetas.find(t => t.idCuentaEntidad === tarjetaSeleccionada);
            
        try {
          if (tarjetaSeleccionada && bancoSeleccionado) {
            const objeto = {
                    "idTarjetaG": tarjeta.idTarjetaG,
                            "idBanco": bancoSeleccionado,
                            "peticion": 5
                      }
                      
           const response = await axios.post ('https://estanciamargarita.com.ar/backendGama/php/servicios/serviciosConvenioTarjetaBanco.php',objeto)
          
           if(response.data.cuotas !== null){
            setCuotasDisponibles(response.data.cuotas)
           } else {

            
            const objetoCuotasBases = {
              
              "idTarjetaG" : tarjeta.idTarjetaG,
              "peticion" : 5
            }
            const traerCuotasBases = await axios.post ('https://estanciamargarita.com.ar/backendGama/php/servicios/serviciosCuotaTarjetas.php', objetoCuotasBases)
            if(traerCuotasBases.data){
             setCuotasDisponibles(traerCuotasBases.data)
            // console.log(traerCuotasBases.data)
            }
          }

          }

        }
        catch(error) {
          console.error('Error al traer Cuotas ' , error)

        }

      }
      traerCuotas()


    }, [tarjetaSeleccionada, bancoSeleccionado]);

useEffect(()=> {
  if (cuotas){
    const porcentaje = porcentajeADecimal(cuotas); // ej: 0.25
const interes = permiteTiparMontos ? Math.round(montoTipado * porcentaje) : Math.round(reserva.totalReserva * porcentaje);
const totalCuotas = permiteTiparMontos ? (Number(montoTipado) + Number(interes)) : (Number(reserva.totalReserva) + Number(interes));
setTotalParaPayway(totalCuotas);
onMontoTotalPayway(totalCuotas);
//console.log(reserva)
//console.log(reserva.totalReserva)
onClickTotalCuotas(totalCuotas)
}


}, [cuotas, montoTipado, ]);



//console.log("monto con intereses", permiteTiparMontos ? montoTipado : reserva.totalReserva)

//console.log(reserva)


return (
    <>

<div className="bg-zinc-400/20 backdrop-blur-2xl rounded-lg shadow-md ring-1 ring-gray-200 p-6 space-y-6">
<Cards
                        cvc={cvv}
                        expiry={mesExp+anioExp}
                        focused={focusedField}
                        name={titularTarjeta}
                        number={numeroTarjeta}
          />


         
    {/* Select de tarjetas */}
    <div className="mb-4">
      <label className="text-sm font-semibold text-gray-800 block mb-1">Tarjeta</label>
      <select
        className="w-full bg-white border border-gray-300 rounded-md px-4 py-2 text-sm text-gray-700 font-medium placeholder:italic placeholder:text-gray-400 placeholder:font-medium shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
        value={tarjetaSeleccionada || ''}
        onChange={(e) => {
          const idCuentaEntidad = e.target.value;
          const filterTarjeta = datosTarjetas.find(t => t.idCuentaEntidad === idCuentaEntidad )
         
          setTarjetaSeleccionada(e.target.value);
          onTarjetaSeleccionada(filterTarjeta);
          setBancoSeleccionado(null);
          setCuotasDisponibles([])
        }}
        onFocus={() => setFocusedField('')}
      >
        <option value="" className="italic">Seleccionar Tarjeta</option>
        {datosTarjetas.map((tarjeta) => (
          <option key={tarjeta.idCuentaEntidad} value={tarjeta.idCuentaEntidad}>
            {tarjeta.descripcion}
          </option>
        ))}
      </select>
    </div>

    {/* Select condicional de bancos */}
    {tarjetaSeleccionada && (() => {
       return (
        <div className="mb-4">
          <label className="text-sm font-semibold text-gray-800 block mb-1">Banco</label>
          <select
            className="w-full bg-white border border-gray-300 rounded-md px-4 py-2 text-sm text-gray-700 font-medium placeholder:italic placeholder:text-gray-400 placeholder:font-medium shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
            value={bancoSeleccionado || ''}
            onChange={(e) => {
             // const bancoId = Number(e.target.value);
              setBancoSeleccionado(Number(e.target.value));
             // const bancoSelected = traerBancos.find(b  => b.idBanco === bancoId )
              onBancoSeleccionado(e.target.value);
              
            }}
            onFocus={() => setFocusedField('')}
          >
            <option value="">Seleccionar Banco</option>
            {traerBancos.map((banco) => (
              <option key={banco.idBanco} value={banco.idBanco}>
                {banco.nombreBanco}
              </option>
            ))}
          </select>
        </div>
        );
    })()}

   
    {cuotasDisponibles.length > 0 && (
      <div className="mb-4">
        <label className="text-sm font-semibold text-gray-800 block mb-1">Cuotas</label>
        <select
          className="w-full bg-white border border-gray-300 rounded-md px-4 py-2 text-sm text-gray-700 font-medium placeholder:italic placeholder:text-gray-400 placeholder:font-medium shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
          onChange={(e)  => {
            setCuotasState(e.target.value);
            onTasa(e.target.value); 
            const cuota = cuotasDisponibles.find(c => c.porcentaje === e.target.value); 
            onCantidadCuotas(cuota)
 }}
          value={cuotas}
          onFocus={() => setFocusedField('')}
        >
          <option value='' className="italic">Seleccione una cuota</option>
          {cuotasDisponibles.map((cuota, i) => (
            <option key={cuota.idCuotaConvenioTarjeta} value={cuota.porcentaje}>
             {cuota.descripcion}
            </option>
          ))}
        </select>
      </div>
    )}

        <div className="space-y-2 mb-4">
              <label className="block text-sm font-semibold text-gray-800">Número de Tarjeta</label>
              <input
                type="text"
                className="w-full bg-white border border-gray-300 rounded-md px-4 py-2 text-sm text-gray-700 font-medium placeholder:italic placeholder:text-gray-400 placeholder:font-medium shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
                placeholder="Número de tarjeta"
                name='number'
                onChange={(e) => {setNumeroTarjetaState(e.target.value); onNumeroTarjeta(e.target.value)}}
                onFocus={() => setFocusedField('number')}
              />
            </div>

            <div className="space-y-2 mb-4">
              <label className="block text-sm font-semibold text-gray-800">Nombre del Titular</label>
              <input
                type="text"
                className="w-full bg-white border border-gray-300 rounded-md px-4 py-2 text-sm text-gray-700 font-medium placeholder:italic placeholder:text-gray-400 placeholder:font-medium shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
                placeholder="Nombre del titular de la tarjeta"
                name='name'
                onChange={(e) =>{setTitularTarjetaState(e.target.value);
                    onTitularTarjeta(e.target.value)
                }}
                onFocus={() => setFocusedField('name')}
              />
            </div>

            <div className="space-y-2 mb-4">
              <label className="block text-sm font-semibold text-gray-800">Fecha de Expiración</label>
              <div className="flex space-x-2">  
                <select
                  className="w-1/2 bg-white border border-gray-300 rounded-md px-4 py-2 text-sm text-gray-700 font-medium placeholder:italic placeholder:text-gray-400 placeholder:font-medium shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
                  name='expiry'
                  onChange={(e) => {setMesExpState(e.target.value); onMesExp(e.target.value)}}
                  onFocus={() => setFocusedField('expiry')}
                >
                  <option value="" className="italic">Mes</option>
                  {[...Array(12)].map((_, i) => {
                    const month = (i + 1).toString().padStart(2, '0');
                    return <option key={month} value={month}>{month}</option>;
                  })}
                </select>

                <select
                  className="w-1/2 bg-white border border-gray-300 rounded-md px-4 py-2 text-sm text-gray-700 font-medium placeholder:italic placeholder:text-gray-400 placeholder:font-medium shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
                  name='expiry'
                  onChange={(e) => {setAnioExpState(e.target.value); onAnioExp(e.target.value)}}
                  onFocus={() => setFocusedField('expiry')}
                >
                  <option value="" className="italic">Año</option>
                  {Array.from({ length: 12 }, (_, i) => {
                    const year = (new Date().getFullYear() + i).toString().slice(2);
                    return <option key={year} value={year}>{year}</option>;
                  })}
                </select>
              </div>
            </div>

            <div className="space-y-2 mb-4">
              <label className="block text-sm font-semibold text-gray-800">CVC</label>
              <input
                type="text"
                className="w-full bg-white border border-gray-300 rounded-md px-4 py-2 text-sm text-gray-700 font-medium placeholder:italic placeholder:text-gray-400 placeholder:font-medium shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
                placeholder="CVC"
                name='cvc'
                onChange={(e) => {setCvvState(e.target.value); onCvv(e.target.value)}}
                onFocus={() => setFocusedField('cvc')}
              />
            </div>

            <div className="space-y-2 mb-4">
              <label className="block text-sm font-semibold text-gray-800">Tipo de Documento</label>
              <select
                className="w-full bg-white border border-gray-300 rounded-md px-4 py-2 text-sm text-gray-700 font-medium placeholder:italic placeholder:text-gray-400 placeholder:font-medium shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
                value={documentoSeleccionado}
                onChange={(e) => {setNumeroDocumentoSeleccionado(e.target.value); 
                  const documento = traerDocumentos.find(c => c.id === Number(e.target.value));  
                  onTipoDocumento(documento)}}
                onFocus={() => setFocusedField('')}
              >
                <option disabled value="" className="italic">Seleccionar Tipo de Documento</option>
                {traerDocumentos.map((doc) => (
                  <option key={doc.sigla} value={doc.id}>{doc.descripcion}</option>
                ))}
              </select>
            </div>
            <div className="space-y-2 mb-4">
              <label className="block text-sm font-semibold text-gray-800">Número de Documento</label>
              <input
                type="text"
                className="w-full bg-white border border-gray-300 rounded-md px-4 py-2 text-sm text-gray-700 font-medium placeholder:italic placeholder:text-gray-400 placeholder:font-medium shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
                placeholder="Número de documento"
                name='numeroDocumento'
                onChange={(e) => {setNumeroDocumentoState(e.target.value); onNumeroDocumento(e.target.value)}}
                onFocus={() => setFocusedField('')}
              />
            </div>
             {permiteTiparMontos && <>
          <div className="mb-4">
            <label className="text-sm font-semibold text-gray-800 block mb-1">Monto base a Pagar</label>
            <input
              type="text"
              className="w-full bg-white border border-gray-300 rounded-md px-4 py-2 text-sm text-gray-700 font-medium placeholder:italic placeholder:text-gray-400 placeholder:font-medium shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
              value={montoTipado}
              max={reserva.saldoReserva}
              onChange={(e) => {
                setMontoTipado(e.target.value);
                onMontoTipado(e.target.value); 

              }}
            />
          </div>
          
          </>}
          <h2 className="text-center text-lg font-bebas">
             Total a pagar: ${totalParaPayway}
             </h2>
</div>

    </>
);
}
